module.exports = __webpack_public_path__ + "img/cj.de23be48.png";